/* eslint-disable max-classes-per-file */
import {
  TableBody as QuillTableBody,
  TableCell as QuillTableCell,
  TableContainer as QuillTableContainer,
  TableRow as QuillTableRow,
} from 'quill/formats/table';
import React from 'react';
import ReactDOM from 'react-dom';
import selectNode from '../../utils/editor/selectNode';
import { RowControl, TableControl } from '../controls/TableControls';

class TableCell extends QuillTableCell {
  select() {
    this.domNode.classList.add('ql-selected');
  }
}

class TableRow extends QuillTableRow {
  constructor(...args: ConstructorParameters<typeof QuillTableRow>) {
    super(...args);
    const uiNode = this.domNode.ownerDocument.createElement('th');
    this.add = this.add.bind(this);
    this.select = this.select.bind(this);
    ReactDOM.render(
      <RowControl
        onAdd={this.add}
        onSelect={() => {
          const table = this.table();
          if (table == null) return;
          // @ts-expect-error
          table.selectNone();
          this.select();
        }}
      />,
      uiNode,
    );
    this.attachUI(uiNode);
  }

  add(offset: number) {
    const table = this.table();
    if (table) {
      // @ts-expect-error
      table.selectNone();
      // @ts-expect-error
      table.insertRow(this.rowOffset() + offset);
    }
  }

  select() {
    this.children.forEach((child) => {
      // @ts-expect-error
      child.select();
    });
  }
}

class TableBody extends QuillTableBody {}

class TableContainer extends QuillTableContainer {
  constructor(...args: ConstructorParameters<typeof QuillTableContainer>) {
    super(...args);
    this.insertColumn = this.insertColumn.bind(this);
    this.insertRow = this.insertRow.bind(this);
    this.selectColumn = this.selectColumn.bind(this);
    this.selectRow = this.selectRow.bind(this);
    this.selectTable = this.selectTable.bind(this);
    this.attachUI(this.domNode.ownerDocument.createElement('thead'));
  }

  attachUI(node: HTMLElement) {
    super.attachUI(node);
    this.renderControl();
  }

  insertColumn(index: number) {
    this.selectNone();
    super.insertColumn(index);
  }

  insertRow(index: number) {
    this.selectNone();
    super.insertRow(index);
  }

  optimize(...args: Parameters<QuillTableContainer['optimize']>) {
    super.optimize(...args);
    if (this.uiNode) {
      this.renderControl();
    }
  }

  renderControl() {
    let numColumns = 1;
    if (this.children.head?.children.head) {
      numColumns = this.children.head.children.head.children.length;
    }
    ReactDOM.render(
      <TableControl
        insertColumn={this.insertColumn}
        numColumns={numColumns}
        selectColumn={this.selectColumn}
        selectTable={this.selectTable}
      />,
      this.uiNode,
    );
  }

  selectNone() {
    selectNode(null, this.domNode);
  }

  selectTable() {
    this.selectNone();
    this.rows().forEach((row) => {
      row.select();
    });
  }

  selectColumn(index: number) {
    this.selectNone();
    this.cells(index).forEach((cell) => {
      cell.select();
    });
  }

  selectRow(index: number) {
    this.selectNone();
    if (this.children.head) {
      const row = this.children.head.children.at(index);
      if (row) {
        // @ts-expect-error
        row.select();
      }
    }
  }
}

export { TableCell, TableRow, TableBody, TableContainer };
